// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4340":"00e4485f","6296":"00e4485f","6401":"00e4485f","7471":"214b13ce","7710":"00e4485f","7900":"00e4485f","8612":"00e4485f"}[chunkId] + ".chunk.css";
};